import template from './illionBankStatementsAuth.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
  controller: class controller {
    constructor($mdDialog) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      ctrl.initialize = () => {
        $mdDialog
          .show({
            template,
            locals: {},
            controllerAs: '$ctrl',
            multiple: true,
            controller() {
              const self = this;
              self.code = '';
              self.isMultiBankEnabled = '';
              self.confirm = () => {
                $mdDialog.hide({
                  code: self.code,
                  isMultiBankEnabled: self.isMultiBankEnabled
                });
              };
              self.cancel = () => {
                $mdDialog.hide();
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            const result = {
              code: res?.code || '',
              isMultiBankEnabled: res?.isMultiBankEnabled || false
            };
            ctrl.onFinish({ result });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
